import {autoRegister, resolve} from "../../container";
import {promiseFromJsonResponse} from "../../common/utils/promises";
import {SecuredRequestExecutor} from "../../module/awswaf/securedRequestExecutor";

const SHARE_DATA_URL = "https://xms.deutsche-boerse.com/chartmod/refreshData?ISIN=DE0005220008&MARKET=DETR";

export type ShareDataResponse = {
    LAST: number;
    DATETIME_LAST_R: number;
    PREVIOUSDAYDIFFVALUE: number;
    PREVIOUSDAYDIFFPERCENT: number;
};


@autoRegister()
export class ShareService {

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
    }

    public async fetch(): Promise<ShareDataResponse> {
        const getRequest = (): Promise<Response> => fetch(`${SHARE_DATA_URL}`);
        const response = await this.securedRequestExecutor.execute(getRequest);
        return promiseFromJsonResponse(response);
    }
}